import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { authService } from '../services/authService';

interface PrivateRouteProps {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const location = useLocation();
  const isAuthenticated = authService.isAuthenticated();

  if (!isAuthenticated) {
    // 将用户重定向到登录页面，同时保存当前路径
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const role = authService.getCurrentUser()?.role;
  if (role === 'readonly' || role === 'audit_admin') {
    const allowed = ['/project-view', '/project-progress', ...(role === 'audit_admin' ? ['/questionnaire-approval'] : [])];
    if (!allowed.includes(location.pathname)) return <Navigate to={role === 'audit_admin' ? '/questionnaire-approval' : '/project-view'} replace />;
  }
  return <>{children}</>;
};

export default PrivateRoute; 